import { KycDetailsLog } from "src/app/kyc/kyc.model";

export class KycResultsAPIRes {
    status: string;
    applicationStatus: string;
    kycRefNo: string;
    uniqueId: string;
    dob: string;
    returnURL: string;
    errMessage: string;
    cKycNo: string;
	firstName: string;
	middleName: string;
	lastName: string;
	address1: string;
	address2: string;
    address3: string;
    uniqueNo: string;
	pan: string;
    gender: string;
	email: string;
	mobile: string;
	companyName: string;
	doi: string;
	customerType: string;
	companyAddress: string;
}

export class KycResultsAPIReq {
    uniqueId: string;
    status: string;
}